"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultFilterBarContainer = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_measure_1 = tslib_1.__importDefault(require("react-measure"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var localization_1 = require("../../localization");
var model_1 = require("../../../model");
var dragAndDrop_1 = require("../../dragAndDrop");
var ShowAllFiltersButton_1 = require("./ShowAllFiltersButton");
var useRowsCalculator_1 = require("./hooks/useRowsCalculator");
var useFilterBarState_1 = require("./hooks/useFilterBarState");
var useFilterExpansionByDragAndDrop_1 = require("./hooks/useFilterExpansionByDragAndDrop");
var DefaultFilterBarContainerCore = function (_a) {
    var children = _a.children;
    var _b = useFilterBarState_1.useFilterBarState(), rows = _b.rows, height = _b.height, isFilterBarExpanded = _b.isFilterBarExpanded, scrollable = _b.scrollable, setFilterBarExpanded = _b.setFilterBarExpanded, setCalculatedRows = _b.setCalculatedRows;
    var dropRef = useFilterExpansionByDragAndDrop_1.useFilterExpansionByDragAndDrop(rows.length > 1, isFilterBarExpanded, setFilterBarExpanded);
    return (react_1.default.createElement("div", { className: "dash-filters-wrapper s-gd-dashboard-filter-bar", ref: dropRef },
        react_1.default.createElement("div", { style: { height: height }, className: classnames_1.default("dash-filters-visible", {
                scrollable: scrollable,
                "s-dash-filters-visible-all": isFilterBarExpanded,
            }) },
            react_1.default.createElement(AllFiltersContainer, { setCalculatedRows: setCalculatedRows }, children),
            react_1.default.createElement(FiltersRows, { rows: rows })),
        react_1.default.createElement(ShowAllFiltersButton_1.ShowAllFiltersButton, { isFilterBarExpanded: isFilterBarExpanded, isVisible: rows.length > 1, onToggle: function (isExpanded) { return setFilterBarExpanded(isExpanded); } }),
        react_1.default.createElement(dragAndDrop_1.BulletsBar, null)));
};
var AllFiltersContainer = function (_a) {
    var setCalculatedRows = _a.setCalculatedRows, children = _a.children;
    var ref = react_1.useRef(null);
    var rowCalculator = useRowsCalculator_1.useRowsCalculator(ref);
    return (react_1.default.createElement(react_measure_1.default, { bounds: true, innerRef: function (rf) { return (ref.current = rf); }, onResize: function (dimensions) { return setCalculatedRows(rowCalculator(dimensions)); } }, function (_a) {
        var measureRef = _a.measureRef;
        return (react_1.default.createElement("div", { className: "dash-filters-all", ref: measureRef }, children));
    }));
};
var FiltersRows = function (_a) {
    var rows = _a.rows;
    return (react_1.default.createElement(react_1.default.Fragment, null, rows.length > 1 && (react_1.default.createElement("div", { className: "dash-filters-rows" }, rows.map(function (height, index) { return (react_1.default.createElement("div", { className: "dash-filters-row", style: { height: height }, key: index })); })))));
};
/**
 * @internal
 */
exports.DefaultFilterBarContainer = function (_a) {
    var children = _a.children;
    var locale = model_1.useDashboardSelector(model_1.selectLocale);
    return (react_1.default.createElement(localization_1.IntlWrapper, { locale: locale },
        react_1.default.createElement(DefaultFilterBarContainerCore, null, children)));
};
//# sourceMappingURL=DefaultFilterBarContainer.js.map